import { ErrorInterface } from '../../../utils/types/common';

export const errorPayload = (error: { code: string; message: string }): ErrorInterface => {
  return {
    code: error.code,
    text: error.message
  };
};
